import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import CommonButton from '../../CommonComponents/CommonButton';
import UpdateUser from '../../CommonComponents/UpdateUser';
import FallbackCard from '../../CommonComponents/FallbackCard';

const headCells = [
  {
    id: 'full_name',
    numeric: false,
    label: 'Name',
  },
  {
    id: 'username',
    numeric: false,
    label: 'Username',
  },
  {
    id: 'depended_field',
    numeric: false,
    label: 'State Name',
  },
  {
    id: 'email',
    numeric: false,
    label: 'Email',
  },
  {
    id: 'mobile',
    numeric: false,
    label: 'Mobile',
  },
  {
    id: 'Edit',
    numeric: false,
    align: 'right',
    label: 'Edit',
  },
  {
    id: 'updatedAt',
    numeric: false,
    label: 'Last Active',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    width: 250,
  },
}));

const MonitorUserTable = ({ allUsers }) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('Name');
  const [updateUser, setUpdateUser] = React.useState(null)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <div>
        {allUsers.length > 0
          ? (
            <Paper className={classes.paper}>
              <TableContainer>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size="medium"
                  aria-label="enhanced table"
                >
                  <EnhancedTableHead
                    headCells={headCells}
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {stableSort(allUsers, getComparator(order, orderBy))
                      .map((row) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          <TableCell>
                            {row.full_name}
                          </TableCell>
                          <TableCell>
                            {row.username}
                          </TableCell>
                          <TableCell>
                            {row.depended_field}
                          </TableCell>
                          <TableCell>
                            {row.email}
                          </TableCell>
                          <TableCell>
                            {row.mobile}
                          </TableCell>
                          <TableCell>
                            <CommonButton
                              color="primary"
                              basic="true"
                              onClick={() => setUpdateUser(row)}
                            >
                              <b>Edit</b>
                            </CommonButton>
                          </TableCell>
                          <TableCell>
                            {moment(row.updatedAt).format('DD MMM YYYY, h:mm:ss a')}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )
          : <FallbackCard text="No data found" />}
      </div>
      {updateUser
        ? <UpdateUser setModal={() => setUpdateUser(null)} user={updateUser} userType="buyer" />
        : null}
    </div>
  );
};

const mapState = (state) => ({
  allUsers: state.dashusers.dashBuyers,
});

const mapAction = null;

export default connect(mapState, mapAction)(MonitorUserTable);
